import $ from "jquery";

export const lineupPriceToggle = () => {
  const $priceWrap = $(".js-lineup-price-wrap");

  $priceWrap.each(function () {
    const $wrap = $(this);
    const $showMoreBtn = $wrap.find(".js-lineup-price-show-more");
    const $priceList = $wrap.find(".js-lineup-price-list");
    const $showMoreText = $wrap.find(".js-lineup-price-show-more-text");

    $showMoreBtn.on("click", () => {
      $priceList.slideToggle();

      // テキストを一度透明にしてからis-activeを切り替えて非透明に戻す
      $showMoreText.animate({ opacity: 0 }, 150, () => {
        $showMoreBtn.toggleClass("is-active");
        $showMoreText.animate({ opacity: 1 }, 300);
      });
    });
  });
};
